import { Group } from '@visx/group';
import { motion } from 'framer-motion';
import { BarChartBar } from './BarChartBar';
import { spring } from './transition';
import { BarSegment, StackedBar } from './types';

export const StackedBars = ({
    bars,
    ...rest
}: {
    bars: StackedBar[];
    showLabels?: boolean;
    overflowLabels: 'horizontal' | 'vertical' | undefined;
    disableAnimation: boolean;
    allowLink: boolean;
    hoveredBarId: string | undefined;
    setHoveredBar: (id: BarSegment | undefined) => void;
}) => {
    if (rest.disableAnimation) {
        return (
            <>
                {bars.map((barStack) =>
                    barStack.bars.map((bar) => (
                        <Group key={`bar-stack-${barStack.index}-${bar.index}`} top={bar.y} left={bar.x}>
                            <BarChartBar bar={bar} {...rest} />
                        </Group>
                    ))
                )}
            </>
        );
    }

    return (
        <>
            {bars.map((barStack) =>
                barStack.bars.map((bar) => (
                    <motion.g
                        key={`bar-stack-${barStack.index}-${bar.index}`}
                        initial={{ x: bar.x, y: bar.y }}
                        animate={{ x: bar.x, y: bar.y }}
                        transition={spring}
                    >
                        <BarChartBar bar={bar} {...rest} />
                    </motion.g>
                ))
            )}
        </>
    );
};
